import { useEffect, useRef, useState } from "react";
import ProjectDeleteModal from "../../../../../components/Modals/ProjectDeleteModal";
import { HiDotsVertical } from "react-icons/hi";
import { FiCopy, FiEdit3, FiFileText, FiTrash2, FiEye } from "react-icons/fi";
import { useJwt } from "../../../../../helpers/common";
import { useOrganizationService, useProjectService } from "../../../../../services";
import DrawerTemplates from "../../../../Templates/AddUpdateTemplate";
import Portal from "../../../../../components/Portal";

const Options = ({ data = {}, openEditProjectModal, onDelete, onViewDetails, className = "", showOnHover = false, hideCopy = false, hideEdit = false }: any) => {
    const [showListGroup, setShowListGroup] = useState(false);
    const [showConfirmModal, setConfirmModal] = useState(false);
    const [toggleCreateModal, setToggleCreateModal] = useState(false)
    const [payloadData, setPayloadData] = useState({});
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const buttonRef = useRef<HTMLButtonElement>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const { copyProject, deleteProjects } = useProjectService();
    const { fetchRecentProjects } = useOrganizationService();
    const JWTdata: any = useJwt()
    const org_id = JWTdata.org_id;

    useEffect(() => {
      if (showListGroup && buttonRef.current) {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const dropdownWidth = 180;
        // More accurate height: 36px per item + 8px padding top/bottom
        const itemCount = 3; // View, Edit, Delete for roadmap; View, Edit, Copy, Template, Delete for project
        const dropdownHeight = itemCount * 36 + 16;
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        const spaceBelow = viewportHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;

        const shouldPositionAbove =
          spaceBelow < dropdownHeight && spaceAbove > dropdownHeight;

        // Position horizontally: prefer right-aligned to button, but don't go off screen
        let leftPos = buttonRect.right - dropdownWidth;
        if (leftPos < 8) {
          leftPos = 8; // Minimum 8px from left edge
        }
        if (leftPos + dropdownWidth > viewportWidth - 8) {
          leftPos = viewportWidth - dropdownWidth - 8;
        }
        setDropdownPosition({
          top: shouldPositionAbove
            ? buttonRect.top - dropdownHeight
            : buttonRect.bottom + 2,
          left: leftPos,
        });
      }
    }, [showListGroup]);

     useEffect(() => {
       const handleClickOutside = (event: MouseEvent) => {
         if (showListGroup && buttonRef.current) {
           const target = event.target as Node;
           // Check if click is inside button or dropdown (via ref)
           if (
             !buttonRef.current.contains(target) &&
             (!dropdownRef.current || !dropdownRef.current.contains(target))
           ) {
             setShowListGroup(false);
           }
         }
       };

       const handleScroll = () => {
         if (showListGroup) {
           setShowListGroup(false);
         }
       };

       const handleResize = () => {
         if (showListGroup) {
           setShowListGroup(false);
         }
       };

       if (showListGroup) {
         document.addEventListener("mousedown", handleClickOutside);
         window.addEventListener("scroll", handleScroll, true);
         window.addEventListener("resize", handleResize);
         return () => {
           document.removeEventListener("mousedown", handleClickOutside);
           window.removeEventListener("scroll", handleScroll, true);
           window.removeEventListener("resize", handleResize);
         };
       }
     }, [showListGroup]);


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (showListGroup && buttonRef.current) {
                const target = event.target as Node;
                const dropdown = document.querySelector('[data-dropdown="options-menu"]');

                if (!buttonRef.current.contains(target) &&
                    (!dropdown || !dropdown.contains(target))) {
                    setShowListGroup(false);
                }
            }
        };

        const handleScroll = () => {
            if (showListGroup) {
                setShowListGroup(false);
            }
        };

        const handleResize = () => {
            if (showListGroup) {
                setShowListGroup(false);
            }
        };

        if (showListGroup) {
            document.addEventListener('mousedown', handleClickOutside);
            window.addEventListener('scroll', handleScroll, true);
            window.addEventListener('resize', handleResize);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
                window.removeEventListener('scroll', handleScroll, true);
                window.removeEventListener('resize', handleResize);
            };
        }
    }, [showListGroup]);

    const handleListClick = (type: any) => {
        if (type === "copy") {
            copyProject(org_id, data)
                .then(() => {
                    fetchRecentProjects(org_id);
                });
            setShowListGroup(false)
        }
        if (type === "editproject") {
            setShowListGroup(false)
            openEditProjectModal?.(data);
        }
        if (type === "createtemplate") {
            setShowListGroup(false)
            setPayloadData({ project_id: data.project_id })
            setToggleCreateModal(true)
        }
        if (type === "deleteProject") {
            setShowListGroup(false)
            setConfirmModal(true)
        }
        if (type === "askCadence") {
            setShowListGroup(false)
        }
        if (type === "viewDetails") {
            setShowListGroup(false)
            onViewDetails?.();
        }
    }

    const handleConfirm = () => {
        setConfirmModal(false)
        if (onDelete) {
            onDelete(data);
        } else {
            deleteProjects(data.project_id, org_id)
                .then(() => {
                    fetchRecentProjects(org_id);
                });
        }
    }

    const menuItems = [
        // ...(onViewDetails ? [{
        //     id: "viewDetails",
        //     label: "View details",
        //     icon: FiEye,
        //     className: "text-light-text-primary hover:text-primary-light hover:bg-light-interactive-hover"
        // }] : []),
        ...(!hideEdit ? [{
            id: "editproject",
            label: "Edit",
            icon: FiEdit3,
            className: "text-light-text-primary hover:text-primary-light hover:bg-light-interactive-hover"
        }] : []),
        ...(!hideCopy ? [{
            id: "copy",
            label: "Make a Copy",
            icon: FiCopy,
            className: "text-light-text-primary hover:text-primary-light hover:bg-light-interactive-hover"
        }] : []),
        {
            id: "createtemplate",
            label: "Create template",
            icon: FiFileText,
            className: "text-light-text-primary hover:text-primary-light hover:bg-light-interactive-hover"
        },
        {
            id: "deleteProject",
            label: "Delete",
            icon: FiTrash2,
            className: "text-light-status-error-text hover:text-red-600 hover:bg-red-50"
        }
    ];

    return (
      <div
        className={`${showOnHover ? "" : "px-4 py-2"} font-medium relative ${className}`}
      >
        <button
          ref={buttonRef}
          onClick={() => setShowListGroup(true)}
          type="button"
          className={`inline-flex items-center justify-center w-8 h-8 rounded-full cursor-pointer text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 ${
            showOnHover
              ? showListGroup
                ? "flex"
                : "group-hover:flex hidden"
              : "flex"
          }`}
          title="More actions"
        >
          <HiDotsVertical className="w-4 h-4" />
        </button>

        {showListGroup && (
                                <Portal>

          <div
            ref={dropdownRef}
            data-dropdown="options-menu"
            className="fixed min-w-[180px] rounded-lg border border-light-border-default dark:border-gray-700 bg-white dark:bg-gray-800 shadow-xl overflow-hidden z-[99999]"
            style={{
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`,
            }}
          >
            <div className="py-2">
              {menuItems.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => handleListClick(item.id)}
                    className={`w-full text-left flex items-center gap-2 px-3 py-2.5 text-sm transition-colors duration-150 ${
                      item.id === "deleteProject"
                        ? "text-red-600 hover:text-red-700 hover:bg-red-50 dark:text-red-400 dark:hover:text-red-300 dark:hover:bg-red-900/20"
                        : "text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                    }`}
                  >
                    <IconComponent className="w-4 h-4" />
                    <span className="text-left leading-tight">
                      {item.label}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
          </Portal>
        )}

        {toggleCreateModal && (
          <Portal>
            <DrawerTemplates
              toggleCreateModal={toggleCreateModal}
              setToggleCreateModal={setToggleCreateModal}
              payloadData={payloadData}
              setPayloadData={setPayloadData}
            />
          </Portal>
        )}

        {showConfirmModal && (
          <Portal>
            <ProjectDeleteModal
              setShowModal={setConfirmModal}
              showModal={showConfirmModal}
              handleConfirm={handleConfirm}
              projectName={data?.project_name}
            />
          </Portal>
        )}
      </div>
    );
}

export default Options;